import React, { useState, useEffect } from 'react';
import { Upload } from 'antd';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default (props) => {
	let { record, setRecord, name, fileName } = props;
	let [file, setFile] = useState([]);
	let [imageUrl, setImageUrl] = useState(false);
	let [loading, setLoading] = useState(false)
	let [uploadStart, setUploadStart] = useState(false)

	const storage = getStorage();

	useEffect(() => {
		if (record[name]) {
			setImageUrl(record[name]);
		}
	}, []);

	let handleChange = info => {
		if (!info.event && uploadStart === false) {
			setUploadStart(true)
			const storageRef = ref(storage, fileName + "/" + info.file.originFileObj.name);
			const metadata = {
				contentType: 'image/jpeg',
			};
			uploadBytes(storageRef, info.file.originFileObj, metadata).then((snapshot) => {
				getDownloadURL(ref(storage, fileName + "/" + info.file.originFileObj.name))
					.then((url) => {
						setFile(info.file.originFileObj);
						setImageUrl(url);
						setRecord({ ...record, [name]: url })
						setUploadStart(false)
					})
					.catch((error) => {
						// Handle any errors
					});
			});
		}
	};

	let beforeUpload = () => {
		setImageUrl(false)
		setLoading(true);
	}
	const uploadButton = (
		<div>
			{loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div style={{ marginTop: 8 }}>Upload</div>
		</div>
	);

	return <>
		<Upload
			name={name}
			listType="picture-card"
			className="avatar-uploader"
			showUploadList={false}
			beforeUpload={beforeUpload}
			onChange={handleChange}
		>
			{imageUrl ? <img src={imageUrl} alt={name} style={{ width: '100%' }} /> : uploadButton}
		</Upload>
	</>
};
